module.exports = __webpack_public_path__ + "static/media/danxuanweixuan.02ba23dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/yysChargingOperator/share/images/danxuanweixuan.png
// module id = 1220
// module chunks = 0